<section class="relative mt-[42px] md:pb-24 pb-16">
  <div class="container mt-10">
    We zijn steeds op zoek naar gemotiveerde collega's om ons multidisciplinaire team te versterken. Neem snel een kijkje en contacteer ons bij interesse!
  </div>
  <div class="container mt-10">
      <div class="grid grid-cols-1 gap-[30px]">

        <div *ngFor="let vacature of vacatures" class="group relative overflow-hidden md:flex justify-between items-center rounded shadow hover:shadow-md dark:shadow-gray-700 transition-all duration-500 p-5">
              <div class="flex items-center">
                  <div class="w-14 h-14 flex items-center justify-center bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                      <img src="assets/images/logo_square_bare.png" class="h-12 h-12"  alt="">
                  </div>
                  <a [routerLink]="['/vacature']" [queryParams]="{vacature: vacature.id}" routerLinkActive="router-link-active" class="text-lg hover:text-earth-xdark font-semibold transition-all duration-500 ltr:ml-3 rtl:mr-3 min-w-[180px]">{{ vacature.titel }}</a>
              </div>

              <div class="md:block flex justify-between md:mt-0 mt-4">
                  <span class="block text-slate-400 text-sm md:mt-1 mt-0"><i class="uil uil-clock"></i> {{ vacature.start }}</span>
              </div>

              <div class="md:block flex justify-between md:mt-0 mt-2">
                  <span class="text-slate-400"><i class="uil uil-map-marker"></i> <span *ngFor="let v of vacature.vestigingen;let i=index; first as isFirst"><span *ngIf="!isFirst">,</span> {{ v.naam }}</span></span>
              </div>

              <div class="md:mt-0 mt-4">
                  <a [routerLink]="['/vacature']" [queryParams]="{vacature: vacature.id}" routerLinkActive="router-link-active" class="btn bg-earth-try hover:bg-earth-dark border-earth-common hover:border-black/70 text-black/70 hover:text-black/70 rounded-md mt-3">Bekijken</a>
              </div>

              <span class="w-24 bg-earth-xdark text-white text-center absolute ltr:-rotate-45 rtl:rotate-45 ltr:-left-[30px] rtl:-right-[30px] top-1"><i class="uil uil-star"></i></span>
          </div><!--end content-->


      </div><!--end grid-->
  </div><!--end container-->

</section>
